export default __webpack_public_path__ + "static/media/Friction8Img.f54afc78.jpg";